// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"330":"5bcec3ad","867":"a1015867"}[chunkId] + ".chunk.js";
};